import React from 'react';

import vid1 from '../images/vid1 (1).mp4';
import vid2 from '../images/vid1 (2).mp4';
import vid3 from '../images/vid1 (3).mp4';
import vid4 from '../images/lvids.mp4';

const Video = () => {
    return (
        <div className="container my-4">
            <h2 className='text-center mt-4'>Our Videos</h2>
            <div className="row">
                {/* Video 1 */}
                <div className="col-md-4 mb-4">
                    <video controls className="w-100">
                        <source src={vid1} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                {/* Video 2 */}
                <div className="col-md-4 mb-4">
                    <video controls className="w-100">
                        <source src={vid2} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>

                {/* Video 3 */}
                <div className="col-md-4 mb-4">
                    <video controls className="w-100">
                        <source src={vid3} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>


                <div className="col-md-4 mb-4">
                    <video controls className="w-100">
                        <source src={vid4} type="video/mp4" />
                        Your browser does not support the video tag.
                    </video>
                </div>


            </div>
        </div>
    );
};

export default Video;
